import {
  FETCH_TEMPLATE_REQUEST, FETCHING_TEMPLATE_SUCCEEDED, FETCHING_TEMPLATE_FAILED, 
  FETCH_CATEGORIES_AND_INDUSTRIES_REQUEST, FETCHING_CATEGORIES_AND_INDUSTRIES_SUCCEEDED, FETCHING_CATEGORIES_AND_INDUSTRIES_FAILED,
  CREATE_TEMPLATE_REQUEST, CREATING_TEMPLATE_SUCCEEDED, CREATING_TEMPLATE_FAILED,
  UPDATE_TEMPLATE_REQUEST, UPDATING_TEMPLATE_SUCCEEDED, UPDATING_TEMPLATE_FAILED,
  DELETE_TEMPLATE_REQUEST,DELETING_TEMPLATE_SUCCEEDED, DELETING_TEMPLATE_FAILED,
  UPDATE_TEMPLATE_VISIBILITY_REQUEST, UPDATING_TEMPLATE_VISIBILITY_SUCCEEDED, UPDATING_TEMPLATE_VISIBILITY_FAILED
} from 'constants/actionTypes';

import _ from 'lodash';

const initialState = {
  loading: false,
  items: []
}

export function templateReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_TEMPLATE_REQUEST: 
      return {
        ...state,
        loading: true
      }

    case FETCHING_TEMPLATE_SUCCEEDED: 
      var records = action.payload.records;
      var items = [];

      if (action.payload.currentPage !== 0) {
        items = [...state.items, ...records];
      } else {
        items = records
      }

      items = _.uniqBy(items, 'id');

      return {
        ...state,
        loading: false,
        items: items,
        pagination: {
          ...state.pagination,
          current: action.payload.currentPage,
          totalPages: action.payload.totalPages,
          totalRecordsCount: action.payload.totalRecordsCount
        }
      }

    case FETCHING_TEMPLATE_FAILED:
      return {
        ...state,
        loading: false,
        loading: false,
        error: action.payload
      }

    case FETCH_CATEGORIES_AND_INDUSTRIES_REQUEST: 
      return {
        ...state,
      }

    case FETCHING_CATEGORIES_AND_INDUSTRIES_SUCCEEDED: 
      var categories = action.payload.categories;
      var industries = action.payload.industries;

      return {
        ...state,
        loading: false,
        categories: categories,
        industries: industries
      }

    case FETCHING_CATEGORIES_AND_INDUSTRIES_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload
      }

    case CREATE_TEMPLATE_REQUEST: 
      return {
        ...state,
        creating: true
      }

    case CREATING_TEMPLATE_SUCCEEDED: 
      return {
        ...state,
        creating: false
      }

    case CREATING_TEMPLATE_FAILED:
      return {
        ...state,
        creating: false,
        error: action.payload
      }

    case UPDATE_TEMPLATE_REQUEST: 
      return {
        ...state,
        updating: true
      }

    case UPDATING_TEMPLATE_SUCCEEDED: 
      return {
        ...state,
        updating: false
      }

    case UPDATING_TEMPLATE_FAILED:
      return {
        ...state,
        updating: false,
        error: action.payload
      }
    
    case DELETE_TEMPLATE_REQUEST: 
      return {
        ...state,
        deleting: true
      }

    case DELETING_TEMPLATE_SUCCEEDED: 
      return {
        ...state,
        deleting: false
      }

    case DELETING_TEMPLATE_FAILED:
      return {
        ...state,
        deleting: false,
        error: action.payload
      }

    case UPDATE_TEMPLATE_VISIBILITY_REQUEST: {
      const { id } = action.payload;

      let templates = [...state.items];

      templates = templates.map(template => {
        if (template.id === id) {
          return {
            ...template,
            updating: true
          }
        }
        return template;
      })

      return {
        ...state,
        items: templates,
      }
    }

    case UPDATING_TEMPLATE_VISIBILITY_SUCCEEDED: {
      const { id, response } = action.payload;

      let templates = [...state.items];

      templates = templates.map(template => {
        if (template.id === id) {
          return {
            ...response,
            updating: false
          }
        }
        return template;
      })

      return {
        ...state,
        items: templates,
      }
    }

    case UPDATING_TEMPLATE_VISIBILITY_FAILED: {
      const { id, response } = action.payload;

      let templates = [...state.items];

      templates = templates.map(template => {
        if (template.id === id) {
          return {
            ...template,
            updating: false
          }
        }
        return template;
      })

      return {
        ...state,
        items: templates,
      }
    }

    default:
      return state
    }
}